import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { InfoOutline } from '@lyearn/icons';
import { Box, InfoPill, Stack, Tooltip, Typography } from '@lyearn/ui';

import { RestrictedVisibilitySettingsContentProps } from '../../types';

type Props = Pick<
  RestrictedVisibilitySettingsContentProps,
  'label' | 'showInfoTooltip' | 'disabled' | 'overrides'
> & {
  countLabel?: string;
};

const Header: React.FC<Props> = (props) => {
  const { overrides, showInfoTooltip, label, disabled, countLabel } = props;
  const { t } = useTranslation();

  if (disabled) {
    return null;
  }

  return (
    <Stack alignItems="center" className="mb-4 w-full px-8" justifyContent="between">
      <Stack alignItems="center">
        <Typography
          color={overrides?.label?.colors ?? 'text-text-primary'}
          variant={overrides?.label?.variant ?? 'label-02'}>
          {label}
        </Typography>
        {showInfoTooltip ? (
          <Tooltip placement="right" title={t('VisibilitySetting:InfoTooltip')!}>
            <Box className="ms-4">
              <InfoOutline className="h-18 w-18" fillColorToken="icon-secondary" />
            </Box>
          </Tooltip>
        ) : null}
      </Stack>
      {countLabel ? <InfoPill appearance="secondary" label={countLabel} type="text" /> : null}
    </Stack>
  );
};

export default Header;
